import React, { useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ThemeContext } from '../utils/context';

const LoginSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setLoggedIn } = useContext(ThemeContext);

  useEffect(() => {
    // URL nundi token extract chestunnam: ?token=your_jwt_token
    const params = new URLSearchParams(location.search);
    const token = params.get('token');

    if (token) {
      // Token ni storage lo dachi status update chestunnam
      localStorage.setItem('token', token);
      setLoggedIn(true);
      // Home page ki redirect
      navigate('/');
    } else {
      console.error("Token not found in URL");
      navigate('/');
    }
  }, [location, navigate, setLoggedIn]);

  return (
    <div className="h-screen flex items-center justify-center bg-white dark:bg-slate-900">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-slate-600 dark:text-slate-400 font-bold">Completing Login...</p>
      </div>
    </div>
  );
};

export default LoginSuccess;